import React from "react";

import { BaseSkeleton } from "components/Skeleton";
import {
  SkeletonCard,
  SkeletonContent,
  SkeletonGrid,
  SkeletonHeader,
  SkeletonHero,
  SkeletonRoot,
} from "./styled";

export default function LearningPathDetailsSkeleton() {
  return (
    <SkeletonRoot>
      <BaseSkeleton height={16} width={112} />
      <SkeletonHero>
        <SkeletonHeader>
          <BaseSkeleton height={44} width="min(520px, 72vw)" />
          <BaseSkeleton height={18} width="min(680px, 76vw)" />
          <BaseSkeleton height={18} width="min(520px, 64vw)" />
          <BaseSkeleton height={8} width="min(520px, 72vw)" borderRadius={999} />
          <BaseSkeleton height={44} width={126} borderRadius={10} />
        </SkeletonHeader>
        <BaseSkeleton height="100%" width="100%" borderRadius={8} />
      </SkeletonHero>
      <SkeletonContent>
        <BaseSkeleton height={12} width={120} />
        <BaseSkeleton height={38} width="min(360px, 70vw)" />
        <SkeletonGrid>
          {Array.from({ length: 4 }).map((_, index) => (
            <SkeletonCard key={index}>
              <BaseSkeleton height={190} borderRadius={18} />
              <BaseSkeleton height={22} width={index % 2 ? "58%" : "72%"} />
              <BaseSkeleton height={16} width="42%" />
            </SkeletonCard>
          ))}
        </SkeletonGrid>
      </SkeletonContent>
    </SkeletonRoot>
  );
}
